import {AbstractPanel} from '../stats-panel';
import type {RenderingContext} from '../types';
import {patch} from '../utils';

export class TexturesPanel extends AbstractPanel {
    private static _realCreateTexture: RenderingContext['createTexture'];
    private static _realDeleteTexture: RenderingContext['deleteTexture'];

    private _gl!: RenderingContext;
    private _texturesCount = 0;

    public constructor(name = 'TS', bg = '#033', fg = '#0c6', max = 100, decimals = 0) {
        super(name, bg, fg, max, decimals);
    }

    public get value(): number {
        return this._texturesCount;
    }

    public update(): void {
        //
    }

    public onInstall(gl?: RenderingContext): void {
        if (!gl) {
            throw Error('Stats: TexturesPanel > Rendering context must be provided');
        }

        this._gl = gl;

        TexturesPanel._realCreateTexture = gl.createTexture;
        TexturesPanel._realDeleteTexture = gl.deleteTexture;

        gl.createTexture = patch(gl.createTexture, this._fakeCreateTexture.bind(this));
        gl.deleteTexture = patch(gl.deleteTexture, this._fakeDeleteTexture.bind(this));
    }

    public onUninstall(): void {
        this._gl.createTexture = TexturesPanel._realCreateTexture;
        this._gl.deleteTexture = TexturesPanel._realDeleteTexture;
    }

    private _fakeCreateTexture(result: WebGLTexture | null, ...args: any[]): void {
        if (!result) {
            return;
        }

        this._texturesCount++;
    }

    private _fakeDeleteTexture(result: void, ...args: any[]): void {
        this._texturesCount--;
    }
}
